import http from "@services/httpService"
import { L } from "@lib/abpUtility"
import { notifyError } from "@lib/helper"
import { PagedResultDto } from "@services/dto/pagedResultDto"
import { SaleEventModel } from "@models/saleEvent/customerModel"

class InvitationService {
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/BookingInvitation/Get", {
      params: { id },
    })
    const { result } = res.data
    return SaleEventModel.assign(result)
  }

  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get("api/services/app/BookingInvitation/GetAll", {
      params,
    })
    return res.data.result
  }
}

export default new InvitationService()
